import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldAlert } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { API_V1 } from "@/lib/api";

export default function MagicLink() {
  const { token } = useParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API_V1}/auth/magic/${token}`);
        if (!active) return;
        login(res.data);
        navigate("/", { replace: true });
      } catch (err) {
        if (!active) return;
        setError(err?.response?.data?.detail || "Magic link is invalid or expired.");
      }
    })();
    return () => {
      active = false;
    };
  }, [token, login, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-6" data-testid="magic-link-page">
      {!error ? (
        <div className="flex flex-col items-center text-center">
          <Loader2 className="w-6 h-6 animate-spin text-slate-500" />
          <div className="mt-4 axia-overline">Signing you in</div>
          <div className="font-display text-xl font-semibold text-slate-900 mt-1">Please wait…</div>
        </div>
      ) : (
        <div className="max-w-sm w-full text-center">
          <ShieldAlert className="w-8 h-8 text-rose-500 mx-auto" />
          <div className="font-display text-xl font-semibold text-slate-900 mt-3">Link expired</div>
          <p className="text-sm text-slate-500 mt-2">{error}</p>
          <button
            onClick={() => navigate("/login")}
            className="mt-5 inline-flex h-10 px-4 items-center bg-slate-900 text-white text-sm rounded-md hover:bg-slate-800"
            data-testid="magic-link-back"
          >
            Back to sign-in
          </button>
        </div>
      )}
    </div>
  );
}
